import React from 'react';

import { Box, Divider, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import RoundedBox from '../RoundedBox';

import { PADDING } from './ListTableWrapper.constants';
import {
  dividerStyles,
  getListTableContainerStyles,
  titleContainerCustomStyles,
} from './ListTableWrapper.styles';

const defaultObject = {};

const ListTableWrapper = ({
  title = '',
  isFullWidthDivider = false,
  customStyles = defaultObject,
  children = null,
  titleVariant = 'medium20',
  control = null,
}) => {
  return (
    <RoundedBox
      customStyles={getListTableContainerStyles({ customStyles, isFullWidthDivider })}
      padding={isFullWidthDivider ? 0 : PADDING}
    >
      {(title || control) && (
        <Box className="titleContainer" sx={titleContainerCustomStyles}>
          {title && (
            <Typography className="title" variant={titleVariant}>
              {title}
            </Typography>
          )}
          {control}
        </Box>
      )}

      <Divider className="divider" sx={dividerStyles} />

      {children}
    </RoundedBox>
  );
};

ListTableWrapper.propTypes = {
  titleVariant: PropTypes.string,
  children: PropTypes.node,
  customStyles: PropTypes.object,
  title: PropTypes.string,
  isFullWidthDivider: PropTypes.bool,
  control: PropTypes.node,
};

export default ListTableWrapper;
